import { CrtRolePermissions } from '../../permissions'

const CRT_FINANCIAL_ANALYST: CrtRolePermissions = {
  crt_agreements_create: true,
  crt_agreements_view: true,
  crt_async_exports_view: true,
  crt_audit_trails_view: false,
  crt_azure_imports_delete: false,
  crt_azure_imports_manage: false,
  crt_azure_imports_view: true,
  crt_brand_variants_view: true,
  crt_budget_allocations_create: true,
  crt_budget_allocations_delete: true,
  crt_budget_allocations_edit: true,
  crt_budget_allocations_view: true,
  crt_budget_estimates_edit: true,
  crt_budget_tracker_view: true,
  crt_calculation_run_accruals_create: true,
  crt_calculation_run_accruals_delete: true,
  crt_calculation_run_accruals_edit: true,
  crt_calculation_run_accruals_view: true,
  crt_bpc_actuals_view: true,
  crt_bpc_actuals_create: true,
  crt_bpc_actuals_edit: true,
  crt_bpc_actuals_delete: true,
  crt_channel_mix_create: true,
  crt_channel_mix_delete: true,
  crt_channel_mix_edit: true,
  crt_channel_mix_view: true,
  crt_commercial_partners_view: true,
  crt_consumer_rates_edit: true,
  crt_consumer_rates_view: true,
  crt_currency_rates_manage: true,
  crt_cost_of_goods_create: true,
  crt_cost_of_goods_delete: true,
  crt_cost_of_goods_edit: true,
  crt_cost_of_goods_view: true,
  crt_versions_approve: false,
  crt_versions_create: true,
  crt_versions_delete: true,
  crt_versions_edit: true,
  crt_versions_view: true,
  crt_lmc_targets_edit: true,
  crt_lmc_targets_view: true,
  crt_distribution_banner_mix_edit: true,
  crt_distribution_banner_mix_view: true,
  crt_distribution_margin_mix_create: true,
  crt_distribution_margin_mix_delete: true,
  crt_distribution_margin_mix_edit: true,
  crt_distribution_margin_mix_view: true,
  crt_federal_excise_edit: true,
  crt_federal_excise_view: true,
  crt_investments_view: true,
  crt_invites_delete: false,
  crt_invites_send: false,
  crt_invites_view: false,
  crt_ip_accruals_create: true,
  crt_ip_accruals_delete: true,
  crt_ip_accruals_edit: true,
  crt_ip_accruals_export: true,
  crt_ip_accruals_view: true,
  crt_key_account_contract_estimates_delete: true,
  crt_key_account_contract_estimates_edit: true,
  crt_key_account_contract_estimates_view: true,
  crt_key_accounts_view: true,
  crt_manual_investments_create: true,
  crt_manual_investments_delete: true,
  crt_manual_investments_edit: true,
  crt_manual_investments_view: true,
  crt_materials_materials_list_view: true,
  crt_materials_price_list_view: true,
  crt_notifications_manage: false,
  crt_notifications_view: false,
  crt_pe_pricing_assumptions_create: true,
  crt_pe_pricing_assumptions_delete: true,
  crt_pe_pricing_assumptions_edit: true,
  crt_pe_pricing_assumptions_view: true,
  crt_pe_pricing_rate_table_view: true,
  crt_pe_tax_assumptions_create: true,
  crt_pe_tax_assumptions_delete: true,
  crt_pe_tax_assumptions_edit: true,
  crt_pe_tax_assumptions_view: true,
  crt_product_type_variant_create: true,
  crt_product_type_variant_view: true,
  crt_product_types_edit: true,
  crt_product_types_view: true,
  crt_material_group_overrides_edit: true,
  crt_material_group_overrides_view: true,
  crt_agreement_mappings_edit: true,
  crt_agreement_mappings_view: true,
  crt_rap_forecasts_create: true,
  crt_rap_forecasts_delete: true,
  crt_rap_forecasts_edit: true,
  crt_rap_forecasts_view: true,
  crt_retailer_margins_fmc_edit: true,
  crt_retailer_margins_fmc_view: true,
  crt_retailer_margins_nc_edit: true,
  crt_retailer_margins_nc_view: true,
  crt_retailer_rates_edit: true,
  crt_retailer_rates_view: true,
  crt_roles_view: false,
  crt_sales_deal_actuals_create: true,
  crt_sales_deal_actuals_delete: true,
  crt_sales_deal_actuals_edit: true,
  crt_sales_deal_actuals_export: true,
  crt_sales_deal_actuals_view: true,
  crt_pnl_actuals_view: true,
  crt_pnl_forecasts_view: true,
  crt_price_list_snapshots_refresh: false,
  crt_unreleased_materials_edit: true,
  crt_unreleased_materials_view: true,
  crt_upload_allUploads_view: false,
  crt_upload_myUpload_view: true,
  crt_users_manageAccess: false,
  crt_users_view: false,
  crt_variance_analysis_view: true,
  crt_volume_forecasts_configure: true,
  crt_volume_forecasts_view: true,
  crt_volume_scenarios_view: true,
  crt_volume_scenarios_create: true,
  crt_volume_scenarios_edit: true,
  crt_volume_scenarios_delete: true,
  crt_wholesaler_margins_fmc_edit: true,
  crt_wholesaler_margins_fmc_view: true,
  crt_wholesaler_margins_nc_edit: true,
  crt_wholesaler_margins_nc_view: true,
}

export default CRT_FINANCIAL_ANALYST
